import '../styles/crm-status-badge.css';

function CrmStatusShieldIcon() {
  return (
    <svg className="crm-status-badge__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10 2.8 4.2 5.1v4.4c0 3.1 2.5 5.4 5.8 6.9 3.3-1.5 5.8-3.8 5.8-6.9V5.1L10 2.8Z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinejoin="round"
      />
      <path
        d="M7.6 10.1 9.2 11.7 12.6 8.3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function CrmStatusBadge({
  label,
  tone = 'muted',
  compact = false,
  showDot = false,
  showShield = false,
  className = '',
  title
}) {
  if (!label) return null;
  const rootClass = [
    'crm-status-badge',
    `crm-status-badge--${tone}`,
    compact ? 'crm-status-badge--compact' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={rootClass} title={title || label}>
      {showShield ? <CrmStatusShieldIcon /> : null}
      {showDot ? <span className="crm-status-badge__dot" aria-hidden="true" /> : null}
      <span>{label}</span>
    </span>
  );
}

export function CrmStatusBadgeFrom({ badge, compact = false, className = '', title }) {
  if (!badge?.label) return null;
  return (
    <CrmStatusBadge
      label={badge.label}
      tone={badge.tone}
      compact={compact}
      showDot={badge.showDot}
      showShield={badge.showShield}
      className={className}
      title={title || badge.label}
    />
  );
}
